import { IfAbility } from '@efdigital/ll-addon-auth';
import type { MediaImage } from '@efdigital/ll-addon-data';
import { Heading } from '@efdigital/ll-addon-ui';
import { ImageUploader } from '@efdigital/ll-admin-v2/components/media/image-uploader.gts';
import { LinkTo } from '@ember/routing';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class LibraryMediaImagesUpload extends Component {
  @service declare router: RouterService;

  onImageUploaded = (image: MediaImage) => {
    this.router.transitionTo('library.media-images.edit', image.id!);
    return Promise.resolve();
  };

  <template>
    <div class="container py-5">
      <Heading @text="Image Library" @secondary="Upload Image">
        <LinkTo
          @route="library.media-images.index"
          class="btn btn-sm btn-primary"
        >
          <iconify-icon inline icon="ph:arrow-left" />
          Back to Image Library
        </LinkTo>
      </Heading>

      <IfAbility @ability="library" @atLeast="editor">
        <:if>
          <ImageUploader @onImageUploaded={{this.onImageUploaded}} />
        </:if>
        <:else>
          <div class="alert alert-warning">
            You do not have permission to upload images to the library.
          </div>
        </:else>
      </IfAbility>
    </div>
  </template>
}
